<template>
  <b-modal
    id="add-members"
    ref="add-members"
    modal-class="add-member-to-department"
    size="sm-size"
    centered
    hide-footer
    hide-header
    @hide="close"
  >
    <div class="modal-head">
      <h2 class="modal-title">
        {{ label.get('add_members_to_department') }}
      </h2>
    </div>
    <div class="content-wrapper hasScroll">
      <perfect-scrollbar>
        <div
          v-for="(departmentItem, index) in departments"
          :key="index"
          class="department-wrapper"
        >
          <span class="department-title">
            {{ departmentItem.department }}
          </span>
          <ul class="department-members">
            <li
              v-for="(member, idx) in departmentItem.members"
              :key="idx"
            >
              <b-form-checkbox
                v-model="member.selected"
                class="radio-checkbox"
              >
                {{ member.name }}
              </b-form-checkbox>
            </li>
          </ul>
        </div>
      </perfect-scrollbar>
    </div>
    <div class="modal-footer">
      <div class="form-buttons">
        <button
          class="atto-btn cancel"
          @click="close"
        >
          {{ label.get('cancel') }}
        </button>
        <button
          class="atto-btn submit"
          @click="addMembersToDepartment()"
        >
          {{ label.get('department_add_members') }}
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
    import DepartmentService from '../services/DepartmentService';

    export default {
        name: "AddMembersToDepartmentComponent",
        props: {
            department: {
                type: Object,
                default: () => {
                    return {};
                }
            }
        },
        data() {
            return {
                departments: [] //this.getMembersFromStore()
            }
        },
        mounted() {
            this.$refs['add-members'].show();
        },
        created() {
          this.getGroupedMembers();
        },
        methods: {
            close() {
                this.$root.$emit('hideAddMembersToDep');
            },
            getGroupedMembers() {
                this.$store.commit('showLoading');
                DepartmentService.getDepartmentsMemberList(this.department.id).then((result) => {
                    this.departments = result;
                    this.departments.forEach((department) => {
                        department.members.sort((a, b) => (a.name > b.name) ? 1 : -1).map((member) => {
                            member.selected = false;
                            return member;
                        });
                    });
                    this.$store.commit('hideLoading');
                }).catch((error) => {
                    this.$store.commit('hideLoading');
                });
            },
            getDepartmentMembers(departmentId) {
                const filteredMembers = this.$store.state.members.filter((item) => {
                    return item.department_id === departmentId;
                }).sort((a, b) => (a.name > b.name) ? 1 : -1);

                return filteredMembers.map((item) => {
                    return {
                        email: item.email,
                        id: item.id,
                        label: "",
                        name: item.name,
                        role_id: item.role_id,
                        type: "member",
                        selected: false
                    };
                });
            },
            addMembersToDepartment() {
                let members = [];
                this.departments.forEach((department) => {
                    const selectedMembers = department.members.filter((member) => {
                        return member.selected;
                    });
                    members.push(...selectedMembers);
                });

                const memberIds = members.map((item) => { return item.id; });

                if(memberIds.length === 0) {
                    return false;
                }

                this.$store.commit('showLoading');
                DepartmentService.addMemberToDepartment({
                    department_id: this.department.id,
                    members: memberIds
                }).then(() => {
                    this.$store.state.members.forEach((item) => {
                        if(memberIds.includes(item.id)) {
                            item.department_id = this.department.id;
                            item.department = this.department;
                        }
                    });
                    this.$store.commit('hideLoading');
                    this.$root.$emit('hideAddMembersToDep', true);
                }).catch(() => {
                    this.$store.commit('hideLoading');
                    this.$awn.alert(this.label.get('an_error_occurred_while_adding_members_to_this_department'));
                })
            },
            getMembersFromStore() {
                let departments = [];
                departments.push({
                    department: this.label.get('no_department'),
                    members: this.getDepartmentMembers(null)
                });

                const membersDepartments = this.getDistinctMemberDepartments();
                membersDepartments.forEach((item) => {
                    departments.push({
                        department: item.name,
                        members: this.getDepartmentMembers(item.id)
                    });
                });

                return departments;
            },
            getDistinctMemberDepartments() {
                const members = this.$store.state.members.filter((item) => {
                    return item.department_id !== null && item.department_id !== this.department.id;
                });
                const result = [];
                const map = new Map();
                for (const item of members) {
                    if(!map.has(item.department_id)){
                        map.set(item.department_id, true);
                        result.push({
                            id: item.department_id,
                            name: item.department.name
                        });
                    }
                }
                return result;
            }
        }
    }
</script>

<style lang="scss">
  .add-member-to-department{
    .modal-sm-size{
      width: 416px;

      .modal-footer{
        padding: 0 40px 40px;
      }
    }
     .modal-head{
      padding: 40px 40px 32px;
    }
    .modal-content{
      .modal-body{
        .content-wrapper{
          padding: 0 40px 16px 40px;
        }
      }
    }
    .modal-content .content-wrapper > .ps{
      padding-right: 40px;
    }
  }
    .department-wrapper {

        span.department-title {
            font: $roboto-medium 0.6875rem/0.8125rem $roboto-font;
            color:$atto-not-active;
            padding-bottom: 8px;
            border-bottom: 2px solid $atto-light-grey;
            margin-bottom: 22px;
            display: inline-block;
            width: 100%;
            text-transform: uppercase;
            letter-spacing: 0.6px;
        }

        ul.department-members {
            display: flex;
            flex-direction: column;

            li {
                margin-bottom: 16px;
                display: flex;
                flex-direction: column;
            }
        }
        .check-wrapper .custom-radio .custom-control-label{
          font-size: 1rem;
          line-height: 1.5rem;
        }

        .custom-checkbox.radio-checkbox {
            padding-left: 36px;

            .custom-control-input:focus ~ .custom-control-label {
                &::before,
                &::after {
                    box-shadow: none;
                    outline: 0;
                }
            }

            .custom-control-input:not(:disabled):focus:not(:checked) ~ .custom-control-label,
            .custom-control-input:not(:disabled):active ~ .custom-control-label {
                &::before,
                &::after {
                    background-color: transparent;
                    border-color: $atto-dark-grey;
                }
            }

            .custom-control-input:checked ~ .custom-control-label {
                &::before {
                    background-color: transparent;
                    border-color: $atto-teal;
                }

                &::after {
                    background-color: $atto-teal;
                    background-image: none;
                }
            }

            .custom-control-label {
                cursor: pointer;

                &::before {
                    border-radius: 24px;
                    left: -36px;
                    border: 1.5px solid $atto-dark-grey;
                }

                &::after {
                    border-radius: 12px;
                    content: '';
                    width: 12px;
                    height: 12px;
                    left: -30px;
                    top: 6px;
                }
            }
        }
    }
</style>